import { useQueryClient } from '@tanstack/vue-query'

const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_PACKAGING)

const MEAL_PACKAGING_QUERY_KEY = 'meal-packaging-types' as const
const mealPackagingQueryKey = { ...useQueryKeyFactory(MEAL_PACKAGING_QUERY_KEY) }

export const apiMealPackaging = {
	fetchMealPackagingTypes: async () => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IMealPackagingType[]>(`${groupPrefix}`, {
				method: 'GET',
			})

			return { data: data.map(MealPackagingType), meta }
		}

		const config = () => ({
			queryKey: mealPackagingQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		const queryClient = useQueryClient()

		const query = config()

		return (
			queryClient.getQueryData<IApiResponseModel<IMealPackagingTypeModel[]>>(query.queryKey) ??
			(await queryClient.fetchQuery(query))
		)
	},
}
